module.exports = __webpack_public_path__ + "625859381ab8bbef67140a76dca3bd5e.glb";